import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet } from '../lib/api';
import { useAuth } from '../context/AuthContext';

// "New time-off request" badge for admins. Seen-state lives in localStorage
// (per browser) and is stamped whenever the Time Off page is opened.
const SEEN_KEY = 'fst-timeoff-seen';

function sinceMs(): number {
  const raw = localStorage.getItem(SEEN_KEY);
  return raw ? Number(raw) || 0 : Date.now(); // first run: nothing is "new"
}

export function useTimeOffNewCount(): number {
  const { permissions } = useAuth();
  const q = useQuery({
    queryKey: ['timeoff', 'new-count'],
    queryFn: () => apiGet<{ count: number }>(`/api/timeoff/new-count?since=${sinceMs()}`),
    enabled: !!permissions?.approveTimeOff,
    refetchInterval: 60_000,
  });
  return q.data?.count ?? 0;
}

/** Stamp the seen-time on mount (call from the Time Off screen). */
export function useMarkTimeOffSeen(): void {
  const qc = useQueryClient();
  useEffect(() => {
    localStorage.setItem(SEEN_KEY, String(Date.now()));
    void qc.invalidateQueries({ queryKey: ['timeoff', 'new-count'] });
  }, [qc]);
}
